export default {"src":"/uk/_next/static/media/briefcaseIcon.efe8a334.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};